import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ApiResponse } from '../models/api-response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthToken } from '../models/auth-token';
import { AuthCredentials } from '../models/auth-credentials';

const ACCESS_TOKEN_KEY = 'accessToken';
const EXPIRES_ON_KEY = 'expiresOn';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  endpoint: string;

  constructor(private baseService: BaseService) {
    this.endpoint = 'auth';
  }

  public getCurrentToken(): string {
    let accessToken: string = localStorage.getItem(ACCESS_TOKEN_KEY);
    return accessToken;
  }

  public getCurrentTokenExpiration(): number {
    let expiresOn: number = +localStorage.getItem(EXPIRES_ON_KEY);
    return expiresOn;
  }

  public saveCurrentToken(token: AuthToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token.accessToken);
    localStorage.setItem(EXPIRES_ON_KEY, (new Date().getTime() + (token.expiresIn * 1000)).toString());
  }

  public invalidateCurrentToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(EXPIRES_ON_KEY);
  }

  public access(credentials: AuthCredentials): Observable<ApiResponse<AuthToken>> {
    return this.baseService.add<AuthToken>(`${this.endpoint}/access`, credentials)
    .pipe(map(data => {
      let token: AuthToken = data.payload;
      this.saveCurrentToken(token);
      return data;
    }));
  }

  // public refresh(token: AuthToken): Observable<ApiResponse<AuthToken>> {
  //   return this.baseService.add<AuthToken>(this.endpoint, token);
  // }

}
